import { onFormQueryError } from '@common/errors/on-form-query-error';
import { apiClient } from '@common/http/query-client';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { message } from '@ui/i18n/message';
import { toast } from '@ui/toast/toast';

interface PushNotificationFormData {
  selectedUsers: number[]; 
  title: string;
  message: string;
  image?: File;
}

export function useSendPushNotification() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sendPushNotification,
    onSuccess: (data) => {
      toast(message('Notification sent successfully'), {
        position: 'bottom-right',
    });
    },
    onError: (error) => {
      console.error('Failed to send notification', error);
      alert('Failed to send notification');
    }
  });
}

function sendPushNotification(formData: PushNotificationFormData) {
  const fd = new FormData();
  fd.set('user_ids', JSON.stringify(formData.selectedUsers));
  fd.set('title', formData.title);
  fd.set('message', formData.message);
  if (formData.image) {
    fd.set('image', formData.image);
  }

  return apiClient.post('send-notification', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(res => res.data);
}

export interface User {
  id: number;
  first_name: string;
  last_name: string;
  email?: string;
  mobile_number?: string;
}
interface UsersResponse {
  users: User[];
}

export function useUsers() {
  return useQuery({
    queryKey: ['all-users'],
    queryFn: () =>
      apiClient.get<UsersResponse>('all-users').then(res => res.data),
  });
}

export function useUsersByIds(ids: number[]) {
  return useQuery<User[]>({
    queryKey: ['users-by-ids', ids],
    queryFn: () =>
      apiClient
        .get(`users_details`, {
          params: { ids: ids.join(',') },
        })
         .then(res => {
          return res.data; 
        })
          .catch(err => {
          console.error('API Error:', err);
          throw err;
        }),
    enabled: ids.length > 0,
  });
}

type CustomFooterSection = {
  title: string;
  slug: string;
  meta: any;
  body: string;
  model_type: string;
}[];


export function useFooterPages() {
  return useQuery<CustomFooterSection>({
    queryKey: ['footer-pages'],
    queryFn: () =>
      apiClient
        .get('get-footer')
        .then(res => res.data)
        .catch(err => {
          console.error('Footer API Error:', err);
          throw err;
        }),
  });
}



